import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Link from '../Link'
import { truncate } from '../../utils/string'
export default class Tag extends PureComponent {
  render() {
    const { path, name } = this.props
    return (
      <Link className="tag tag--is-square" href={path} title={`Timelines tagged with ${name}`}>
        <span>{truncate(name, 24)}</span>
      </Link>
    )
  }
}
Tag.propTypes = {
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}
